import { AnimatePresence, motion } from "framer-motion";
import { useCallback, useContext, useEffect, useState } from "react";
import CloseIcon from "../../../../components/CloseIcon/CloseIcon.js";
import CustomButtonV2 from "../../../../components/CustomButtonV2/CustomButtonV2.js";
import FiltroV2 from "../../../../components/FiltroV2/FiltroV2.js";
import HeaderCadastro from "../../../../components/HeaderCadastro/HeaderCadastro.js";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import ModalEmbarques from "../../../../components/ModalEmbarques/ModalEmbarques.tsx";
import ModalStatusManual from "../../../../components/ModalStatusManual/ModalStatusManual.tsx";
import ModalUsuario from "../../../../components/ModalUsuario/ModalUsuario.tsx";
import MultiplosFiltrosRedux from "../../../../contexts/MultiplosFiltros.js";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";
import { useToast } from "../../../../contexts/ToastContext.tsx";
import MotionContainer from "../../../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../../../core/components/MotionSemAutorizacao.tsx";
import Separator from "../../../../core/components/Separator.tsx";
import Layout from "../../../../core/layout/Layout.tsx";
import {
	getDataDispDiariaVeiculos,
	primeiroDiaDosMesFormatado,
	ultimoDiaDosMesFormatado,
} from "../../../../core/utils/UtilityDates.ts";
import { getCidadeEstado } from "../../../../services/ModuloGerenciador/CidadeEstado.js";
import {
	deleteStatusManual,
	getDiariaVeiculoSearch,
	getEmbarquesDisponiveis,
	ocultarVeiculo,
} from "../../../../services/ModuloGerenciador/Search.js";
import { getStatus } from "../../../../services/ModuloGerenciador/Status.js";
import { getVeiculo } from "../../../../services/ModuloGerenciador/Veiculo.js";
import "./DiariaVeiculo.css";

const itensFiltro = [
	{
		nomeColuna: "Tipo Carroceria",
		field: "tipoCarroceria",
	},
	{
		nomeColuna: "Descrição",
		field: "descricao",
	},
	{
		nomeColuna: "Empresa",
		field: "empresa",
	},
	{
		nomeColuna: "Filial",
		field: "filial",
	},
	{
		nomeColuna: "Unidade de Embarque",
		field: "unidEmbarque",
	},
	{
		nomeColuna: "Pedido",
		field: "pedido",
	},
	{
		nomeColuna: "CTE",
		field: "cte",
	},
	{
		nomeColuna: "Previsão Viagem",
		field: "previsaoEmbarque",
	},
	{
		nomeColuna: "Data Viagem",
		field: "dataEmbarque",
	},
	{
		nomeColuna: "Previsão Entrega",
		field: "previsaoEntrega",
	},
	{
		nomeColuna: "Data Entrega",
		field: "dataEntrega",
	},
	{
		nomeColuna: "Data Hora Chegada Viagem",
		field: "dataHoraChegadaEmbarque",
	},
	{
		nomeColuna: "Data Hora Chegada Entrega",
		field: "dataHoraChegadaEntrega",
	},
	{
		nomeColuna: "Data Hora Entregue",
		field: "dataHoraEntregue",
	},
	{
		nomeColuna: "Data Hora Embarcado",
		field: "dataHoraEmbarcado",
	},
	{
		nomeColuna: "Aceite",
		field: "aceite",
	},
	{
		nomeColuna: "Status",
		field: "status",
	},
	{
		nomeColuna: "Placa Cavalo",
		field: "placaCavalo",
	},
	{
		nomeColuna: "Placa Carreta",
		field: "placaCarreta",
	},
	{
		nomeColuna: "Placa Segunda Carreta",
		field: "placaCarreta2",
	},
	{
		nomeColuna: "Proprietario",
		field: "proprietario",
	},
	{
		nomeColuna: "Motorista",
		field: "veiculoMotorista",
	},
	{
		nomeColuna: "ICMS",
		field: "icms",
	},
	{
		nomeColuna: "Frete Motorista",
		field: "freteMotorista",
		tipo: "number",
	},
	{
		nomeColuna: "Frete Fiscal",
		field: "freteFiscal",
		tipo: "number",
	},
	{
		nomeColuna: "Adicional Empresa",
		field: "adicionalEmpresa",
		tipo: "number",
	},
	{
		nomeColuna: "Adicional Motorista",
		field: "adicionalMotorista",
		tipo: "number",
	},
	{
		nomeColuna: "Pedagio",
		field: "pedagio",
		tipo: "number",
	},
	{
		nomeColuna: "Classificação",
		field: "classificacao",
		tipo: "number",
	},
	{
		nomeColuna: "Margem",
		field: "margem",
	},
	{
		nomeColuna: "Adiantamento",
		field: "adiantamento",
		tipo: "number",
	},
	{
		nomeColuna: "Saldo",
		field: "saldo",
		tipo: "number",
	},
	{
		nomeColuna: "Meio Pagamento",
		field: "meioPagamento",
	},
	{
		nomeColuna: "Meio Pagamento Dois",
		field: "meioPagamento2",
	},
	{
		nomeColuna: "Km",
		field: "km",
		tipo: "number",
	},
	{
		nomeColuna: "Cliente",
		field: "cliente",
	},
	{
		nomeColuna: "Embarcador",
		field: "embarcador",
	},
	{
		nomeColuna: "Destinatario",
		field: "destinatario",
	},
	{
		nomeColuna: "LOAD",
		field: "load",
	},
	{
		nomeColuna: "Mercadoria",
		field: "mercadoria",
	},
	{
		nomeColuna: "Peso",
		field: "peso",
		tipo: "number",
	},
	{
		nomeColuna: "Embalagem",
		field: "embalagem",
	},
	{
		nomeColuna: "Observação",
		field: "observacao",
	},
	{
		nomeColuna: "Frota",
		field: "frota",
	},
	{
		nomeColuna: "Cancelado",
		field: "cancelado",
	},
	{
		nomeColuna: "Motivo",
		field: "motivo",
	},
	{
		nomeColuna: "Usuário Responsável",
		field: "usuarioResponsavel",
	},
	{
		nomeColuna: "Elegível BRF",
		field: "elegivelBrf",
	},
];

const formatarData = (data) => {
	const [ano, mes, dia] = data.split("-");
	return `${dia}/${mes}/${ano}`;
};

function DiariaVeiculo(props) {
	const [valuesPesquisa, setValuesPesquisa] = useState([]);
	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);
	const { profile, hasRegra } = useProfile();
	const { showToast } = useToast();

	const limpar = () => {
		buscarSearchInicial();
	};

	const buscarSearchInicial = async () => {
		setLoading(true);
		let pesquisaFormatada;
		if (valuesPesquisa.length > 0) {
			pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
		} else {
			pesquisaFormatada = `undefined=`;
		}
		if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
			for (let filtro of multiplosFiltrosRedux) {
				pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
			}
		}

		const { data1Disp, data2Disp } = getDataDispDiariaVeiculos(new Date());

		await getDiariaVeiculoSearch(
			profile?.token,
			"todos",
			primeiroDiaDosMesFormatado,
			ultimoDiaDosMesFormatado,
			data1Disp,
			data2Disp,
			5,
			pesquisaFormatada
		)
			.then((result) => {
				setDadosTabela(result.data);
				setLoading(false);
			})
			.catch((error) => {
				if (error?.response?.data?.length > 200) {
					showToast(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
						"error"
					);
				} else {
					showToast(error.response.data, "error");
				}
			});
		setLoading(false);
	};

	const ocultarVeiculoManual = async () => {
		if (!!idVeiculo) {
			setLoading(true);
			await ocultarVeiculo(idVeiculo, profile?.token)
				.then((result) => {
					setLoading(false);
					buscarSearch();
				})
				.catch((error) => {
					if (error?.response?.data?.length > 200) {
						showToast(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
							"error"
						);
					} else {
						showToast(error.response.data, "error");
					}
				});
			setLoading(false);
		}
	};

	const deletarVeiculo = async () => {
		if (idManual !== null) {
			setLoading(true);
			await deleteStatusManual(idManual, profile?.token)
				.then((result) => {
					setLoading(false);
					buscarSearch();
				})
				.catch((error) => {
					if (error?.response?.data?.length > 200) {
						showToast(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
							"error"
						);
					} else {
						showToast(error.response.data, "error");
					}
				});
			setLoading(false);
		}
	};

	const [listaVeiculos, setListaVeiculos] = useState([]);

	const [listaCidade, setListaCidade] = useState([]);

	const [listaStatus, setListaStatus] = useState([]);

	const [listaEmbarques, setListaEmbarques] = useState([]);

	const buscarEmbarques = async () => {
		await getEmbarquesDisponiveis(
			profile?.token,
			valuesPesquisa.contexto,
			dadosTabela.colunas[colIndex],
			cidadeId,
			pesquisa
		).then((result) => {
			setListaEmbarques(result.data);
			setOpenEmbarques(true);
		});
	};

	const buscarVeiculo = async () => {
		await getVeiculo({ token: profile?.token }).then((result) => {
			setListaVeiculos(result.data);
		});
	};

	const buscarStatus = async () => {
		await getStatus(profile?.token).then((result) => {
			setListaStatus(result.data);
		});
	};

	const buscarCidadeEstado = async () => {
		await getCidadeEstado(profile?.token).then((result) => {
			setListaCidade(result.data);
		});
	};

	const buscarSearch = async () => {
		setLoading(true);
		let pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
		if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
			for (let filtro of multiplosFiltrosRedux) {
				pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
			}
		}

		await getDiariaVeiculoSearch(
			profile?.token,
			valuesPesquisa.contexto,
			valuesPesquisa.embarqueInicio,
			valuesPesquisa.embarqueFinal,
			valuesPesquisa.embarqueInicioDisp,
			valuesPesquisa.embarqueFinalDisp,
			valuesPesquisa.elegivelBrf,
			pesquisaFormatada
		)
			.then((result) => {
				setDadosTabela(result.data);
				setLoading(false);
			})
			.catch((error) => {
				if (error?.response?.data?.length > 200) {
					showToast(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
						"error"
					);
				} else {
					showToast(error.response.data, "error");
				}
			});
		setLoading(false);
	};

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState({});

	const [valuesSelect, setValuesSelect] = useState([]);

	const [validator, setValidator] = useState([]);

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const [openStatusManual, setOpenStatusManual] = useState(false);

	const handleCloseStatusManual = (value) => {
		setOpenStatusManual(false);
		buscarSearch();
	};

	const [openEmbarques, setOpenEmbarques] = useState(false);

	const handleCloseEmbarques = (value) => {
		setOpenEmbarques(false);
	};

	useEffect(() => {
		setValues((current) => ({
			...current,
			usuario: profile?.usuario.usuario,
		}));
		setValues((current) => ({
			...current,
			motorista3: "N/D",
			motorista4: "N/D",
			motorista5: "N/D",
			motorista6: "N/D",
			motorista7: "N/D",
			motorista8: "N/D",
			motorista9: "N/D",
			motorista10: "N/D",
			motorista11: "N/D",
			motorista12: "N/D",
		}));
		setValidator((current) => ({
			...current,
			placaCavalo: "false",
			proprietario: "false",
			motorista: "false",
			tipoCarroceria: "false",
			tipoDiariaVeiculo: "false",
		}));
	}, [loading]);

	useEffect(() => {
		if (props.telaCadastro === true) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	const fetchData = useCallback(async () => {
		await buscarSearchInicial();
		await buscarVeiculo();
		await buscarStatus();
		await buscarCidadeEstado();
	}, [buscarSearchInicial, buscarVeiculo, buscarStatus, buscarCidadeEstado]);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Diária Veículo"));
			fetchData();
		}
	}, [profile?.token]);

	const [linhaSelecionada, setLinhaSelecionada] = useState(null);
	const [colunaSelecionada, setColunaSelecionada] = useState(null);
	const [idManual, setIdManual] = useState(null);
	const [idVeiculo, setIdVeiculo] = useState(null);

	const [cidadeId, setCidadeId] = useState(null);
	const [colIndex, setColIndex] = useState(null);
	const [pesquisa, setPesquisa] = useState("150");

	useEffect(() => {
		if (!!cidadeId && !!colIndex && profile?.token) {
			buscarEmbarques();
		}
	}, [cidadeId, colIndex]);

	const handleTdClick = (linhaIndex, colunaIndex, coluna) => {
		setIdManual(coluna.veiculoStatusManualIds[colunaIndex]);
		setIdVeiculo(coluna.veiculo.idVeiculo);
		setLinhaSelecionada(linhaIndex);
		setColunaSelecionada(colunaIndex);
	};

	const buscarEmbarqueValido = (cidadeIds, currentIndex) => {
		for (let i = currentIndex - 1; i >= 0; i--) {
			if (cidadeIds[i] !== 0) {
				return cidadeIds[i];
			}
		}
		for (let i = currentIndex + 1; i < cidadeIds.length; i++) {
			if (cidadeIds[i] !== 0) {
				return cidadeIds[i];
			}
		}
		return 0;
	};

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout key="DiariaVeiculos" title="Agenda">
			{loading ? (
				<LoadingComponent />
			) : (
				<AnimatePresence mode="wait">
					{!telaCadastro ? (
						<MotionContainer key="DiariaVeiculosScreenContainer">
							<div className="content-container">
								<div>
									<Separator size="md" />
									<FiltroV2
										classe="div-filtrar-embarque-v2"
										classOption="select-options-cliente"
										itensFiltro={itensFiltro}
										valuesPesquisa={valuesPesquisa}
										setValuesPesquisa={setValuesPesquisa}
										buscarSearch={buscarSearch}
										limpar={limpar}
									/>
									<Separator size="md" />
								</div>
								<motion.div
									key="tabelaDiariaVeiculo"
									initial={{ opacity: 0 }}
									animate={{ opacity: 1 }}
									exit={{ opacity: 0 }}
									transition={{ duration: 0.3 }}
									className="tabela-v2"
								>
									<div className="outer-wrapper-v2">
										<div className="table-v2" id="tableWrapper">
											<table className="tabela-diaria-veiculo">
												<thead>
													<tr>
														<th className="th-diaria-veiculo">Placa Veículo</th>
														{dadosTabela?.colunas?.length > 0 &&
															dadosTabela.colunas.map((coluna, index) => (
																<th key={index} className="th-diaria-veiculo">
																	{formatarData(coluna)}
																</th>
															))}
													</tr>
												</thead>
												<tbody>
													{dadosTabela?.veiculos?.length > 0 &&
														dadosTabela.veiculos.map((linha, index) => (
															<tr key={index} className="tr-hover">
																<td className="td-diaria-veiculo">
																	{linha.veiculo?.caminhao?.placa}
																	<br />
																	{linha.motoristaNome}
																</td>
																{dadosTabela?.colunas?.length > 0 &&
																	dadosTabela.colunas.map(
																		(coluna, colIndex) => (
																			<td
																				key={colIndex}
																				className={`td-diaria-veiculo ${
																					linhaSelecionada === index &&
																					colunaSelecionada === colIndex
																						? "linha-selecionada"
																						: ""
																				}`}
																				onClick={() =>
																					handleTdClick(index, colIndex, linha)
																				}
																			>
																				{linha.statusPorDia[colIndex]?.includes(
																					"disp"
																				) ? (
																					<span
																						onClick={(e) => {
																							e.stopPropagation();
																							let cidadeId =
																								linha.cidadeId[colIndex];
																							if (cidadeId === 0) {
																								cidadeId = buscarEmbarqueValido(
																									linha.cidadeId,
																									colIndex
																								);
																							}
																							if (cidadeId !== 0) {
																								setCidadeId(cidadeId);
																								setColIndex(colIndex);
																							}
																						}}
																						style={{
																							textDecoration: "underline",
																							color: "#5353ef",
																						}}
																					>
																						{linha.statusPorDia[colIndex]
																							.split("-")[0]
																							.trim()}
																						<br />
																						{
																							linha.statusPorDia[
																								colIndex
																							].split("-")[1]
																						}
																					</span>
																				) : (
																					linha.statusPorDia[colIndex]
																						?.split("-")[0]
																						?.trim()
																				)}
																			</td>
																		)
																	)}
															</tr>
														))}
												</tbody>
											</table>
										</div>
									</div>
								</motion.div>
							</div>
							<div className="footer-container">
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									width="200px"
									titulo="Adicionar Veículo"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setOpenStatusManual(true);
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-deletar"
									classText="button-texto-cadastrar"
									titulo="Remover Veículo"
									width="190px"
									icone="iconeDelete"
									cor="#DC2D2D"
									valor={values}
									onClick={() => {
										if (idManual) {
											deletarVeiculo();
										} else {
											showToast(
												"Selecione uma coluna para remover o veículo.",
												"error"
											);
										}
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-user"
									classText="button-texto-user"
									titulo="Ocultar Veículo"
									cor="#FFFFFF"
									width="190px"
									valor={values}
									onClick={() => {
										if (idVeiculo) {
											ocultarVeiculoManual();
										} else {
											showToast(
												"Selecione uma coluna para remover o veículo.",
												"error"
											);
										}
									}}
								/>
							</div>
						</MotionContainer>
					) : (
						<MotionContainer key="telaCadastroDiariaVeiculos">
							{!props.desabilitar && (
								<div className="indicadores">
									<p className="indicador-emb">{"Dados de DiariaVeiculo / "}</p>
									{editando ? (
										<p className="indicador-emb">
											{"Detalhes de DiariaVeiculo"}
										</p>
									) : (
										<p className="indicador-emb">
											{"Cadastro de DiariaVeiculo"}
										</p>
									)}
								</div>
							)}
							<div className="flex">
								{!props.botaoVoltar && (
									<div className="flex-emb">
										{editando ? (
											<HeaderCadastro texto="Detalhes de Conjunto" />
										) : (
											<HeaderCadastro texto="Cadastro de Conjunto" />
										)}
										<CloseIcon
											onClick={() => {
												setValues({});
												setValuesSelect({});
												setTelaCadastro(false);
												setEditando(false);
											}}
										/>
									</div>
								)}
							</div>
							<div className="botoes-diariaVeiculo">
								{!props.botaoVoltar && (
									<CustomButtonV2
										classCss="custom-button-cancelar"
										classText="button-texto-cancelar"
										titulo="Cancelar"
										cor="#0946B8"
										valor={values}
										onClick={() => {
											setValues({});
											setValuesSelect({});
											setTelaCadastro(false);
											setEditando(false);
										}}
									/>
								)}
							</div>
						</MotionContainer>
					)}
				</AnimatePresence>
			)}
			<div>
				<ModalUsuario
					titulo="Usuário"
					tituloConfirmar="OK"
					open={openUsuario}
					onClose={handleCloseUsuario}
				/>
				<ModalStatusManual
					titulo="Adicionar Veículo"
					tituloConfirmar="OK"
					open={openStatusManual}
					listaVeiculos={listaVeiculos}
					listaCidade={listaCidade}
					listaStatus={listaStatus}
					onClose={handleCloseStatusManual}
				/>
				<ModalEmbarques
					titulo="Viagens Disponiveis"
					tituloConfirmar="OK"
					open={openEmbarques}
					listaEmbarques={listaEmbarques}
					onClose={handleCloseEmbarques}
					buscarEmbarques={buscarEmbarques}
					setPesquisa={setPesquisa}
					pesquisa={pesquisa}
				/>
			</div>
		</Layout>
	);
}

export default DiariaVeiculo;
